import con from '../../../../connection';
var path = '/password';
var password = function (url) { return function () { return ({
    post: function (param) { return con.post(url + path, param); },
}); }; };
export default password;
